import { kbbTheme } from '@argo/themes';
const {
  none,
  tiny,
  micro,
  xs,
  xs12,
  sm,
  md,
  lg,
  xl,
  mdx2,
  xxl,
  xxxl,
  yuge,
  contentMaxWidth,
  globalNavHeight
} = kbbTheme.size;
export default {
  none,
  tiny,
  micro,
  xs,
  xs12,
  sm,
  md,
  lg,
  xl,
  mdx2,
  xxl,
  xxxl,
  yuge,
  contentMaxWidth,
  globalNavHeight
};
//# sourceMappingURL=size.js.map